import { Inertia } from '@inertiajs/inertia';
import React, { useState } from 'react'
import Select from '@/Components/Select';
import axios from 'axios';

const SoftlandOrderDiff = ({ branchOffices }) => {
    const [selectedMonth, setSelectedMonth] = useState('');
    const [selectedYear, setSelectedYear] = useState('');
    const [branchOfficeSelected, setBranchOfficeSelected] = useState(null);

    const handleMonthChange = (event) => {
        setSelectedMonth(event.target.value);
    };

    const handleYearChange = (event) => {
        setSelectedYear(event.target.value);
    };

    const handleUpload = async (event) => {
        event.preventDefault();

        const formData = new FormData();
        formData.append('csvFile', event.target.csvFile.files[0]);

        const branchOffice = branchOffices.find(({ id }) => id === branchOfficeSelected).slug

        try {
            const response = await axios.post(route('get.softland-differences.csv', { branchOffice, year: selectedYear, month: selectedMonth }), formData, {
                responseType: 'blob',
            });

            const header = response.headers['content-disposition'];
            const regexPattern = 'filename=([^;]+)';
            const regex = new RegExp(regexPattern);

            const match = header.match(regex);

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const a = document.createElement('a');
            a.href = url;
            a.download = match[1];
            a.click();
        } catch (error) {
            console.error('Error uploading CSV:', error);
        }
    };

    return (
        <div className="container">
            <h1>CSV Import</h1>
            <form onSubmit={handleUpload}>

                <Select
                    id="branch_office_id"
                    options={branchOffices?.map(branchOffice => {
                        return {
                            value: branchOffice.id,
                            label: `${branchOffice.name} - ${branchOffice.store}`
                        }
                    })}
                    value={
                        (() => {
                            const branchOffice = branchOffices.find(({ id }) => id === branchOfficeSelected)

                            return branchOfficeSelected && Boolean(branchOffices.length)
                                ? {
                                    value: branchOfficeSelected,
                                    label: `${branchOffice.name} - ${branchOffice.store}`,
                                }
                                : {
                                    value: null,
                                    label: "Seleccione una sucursal",
                                }
                        })()
                    }
                    noOptionsMessage={() =>
                        "No hay sucursales disponibles"
                    }
                    onChange={({value}) => setBranchOfficeSelected(value)}
                />
                <div>
                    <label htmlFor="selectedMonth">Select Month:</label>
                    <input
                        type="number"
                        name="selectedMonth"
                        value={selectedMonth}
                        onChange={handleMonthChange}
                    />
                </div>
                <div>
                    <label htmlFor="selectedYear">Select Year:</label>
                    <input
                        type="number"
                        name="selectedYear"
                        value={selectedYear}
                        onChange={handleYearChange}
                    />
                </div>
                <div>
                    <label htmlFor="csvFile">CSV File:</label>
                    <input type="file" name="csvFile" />
                </div>
                <button type="submit">Upload CSV</button>
            </form>
        </div>
    );
}



export default SoftlandOrderDiff